import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, clsx, Icon, Popover } from '@a-type/ui';
import { useRef, useState, } from 'react';
import cls from '../chat/ChatSurface.module.css';
import { useDndStore } from '../dnd/dndStore.js';
import { Droppable } from '../dnd/Droppable.js';
import { useRendererContext } from '../RendererProvider.js';
import cls2 from './HelpSurface.module.css';
const droppableTags = ['spatial-help-surface'];
export function HelpSurface({ id, children, className, render, disabled, content, title = 'Info', rulesId, ...rest }) {
    const [open, setOpen] = useState(false);
    const { LinkComponent, navigate } = useRendererContext();
    const handleDrop = (draggable) => {
        if (draggable.id !== 'spatial-help')
            return;
        if (!content) {
            // TODO: fix the typings here
            navigate({ search: { help: true }, hash: rulesId });
        }
        else {
            setOpen(true);
        }
    };
    const isHelpDragging = useDndStore((state) => state.dragging === 'spatial-help');
    const anchorRef = useRef(null);
    if (disabled || (!content && !rulesId)) {
        return (_jsx("div", { className: className, "data-help-surface": id, "data-no-help": true, ...rest, children: children }));
    }
    return (_jsxs(Popover, { open: open, onOpenChange: setOpen, children: [_jsx(Droppable, { ref: anchorRef, noParenting: true, id: id, onDrop: handleDrop, accept: (draggable) => draggable.id === 'spatial-help', className: clsx(cls.root, className), "data-is-dragging": isHelpDragging, tags: droppableTags, render: render, "data-help-surface": id, ...rest, children: children }), _jsxs(Popover.Content, { anchor: anchorRef, className: cls.popover, children: [_jsx(Popover.Arrow, {}), _jsx(Popover.Title, { className: cls2.title, children: title }), content, _jsx(Box, { items: "center", justify: "between", gap: "sm", className: cls2.readMore, render: _jsx(Popover.Description, {}), children: _jsxs(Button, { emphasis: "default", size: "small", onClick: () => setOpen(false), render: _jsx(LinkComponent, { to: `?rules=true${rulesId ? `#${rulesId}` : ''}` }), children: [_jsx(Icon, { name: "book" }), "Read more"] }) }), _jsx(Popover.Close, {})] })] }));
}
//# sourceMappingURL=HelpSurface.js.map